import type { AnyObject } from '../../types';
export default function getPictureCreditSourceForMt(images: AnyObject) {
	const objectKeys = Object.keys(images);
	const firstAvailableAspectRatioKey = objectKeys.filter((key) => key.startsWith('aspect'))[0];
	return images[firstAvailableAspectRatioKey].producerName;
}
